import { render, staticRenderFns } from "./LoginTipSSO.vue?vue&type=template&id=5448be2e&scoped=true&"
import script from "./LoginTipSSO.vue?vue&type=script&lang=js&"
export * from "./LoginTipSSO.vue?vue&type=script&lang=js&"
import style0 from "./LoginTipSSO.vue?vue&type=style&index=0&id=5448be2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5448be2e",
  null
  
)

export default component.exports